import React, { PureComponent } from 'react';
import CheckIcon from 'mdi-react/CheckIcon';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { UncontrolledTooltip } from 'reactstrap';

class CheckBoxField extends PureComponent {
  componentDidMount() {
    this.props.onChange(this.props.defaultChecked);
  }

  render() {
    const { disabled, value, name, className, onChange } = this.props;

    return (
      <div>
        <label
          className={classnames('checkbox-btn', 'auto-locale', className, {
            disabled: disabled,
            checked: value
          })}
        >
          <span className="checkbox-btn__label-before">
            Auto select the Country and Language
          </span>
          <input
            className="checkbox-btn__checkbox"
            type="checkbox"
            name={name}
            onChange={onChange}
            checked={value}
            disabled={disabled}
          />
          <span className="checkbox-btn__checkbox-custom after">
            <CheckIcon />
          </span>
          <div id="auto-country" className="info-tooltip">
            ?
          </div>
          <UncontrolledTooltip
            placement="right"
            target="auto-country"
            className="info-tooltip"
          >
            Choose the country and language for your magazine (you can create
            different magazine for different countries and languages)
          </UncontrolledTooltip>
        </label>
      </div>
    );
  }
}

const renderCheckBoxField = props => (
  <CheckBoxField
    {...props.input}
    defaultChecked={props.defaultChecked}
    disabled={props.disabled}
    className={props.className}
  />
);

renderCheckBoxField.propTypes = {
  input: PropTypes.object.isRequired,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  color: PropTypes.string
};

class AutoLocaleCheckbox extends PureComponent {
  render() {
    return (
      <Field
        name="autoLocale"
        className="colored"
        component={renderCheckBoxField}
        labelBefore="Auto select the Country and Language"
      />
    );
  }
}

export default AutoLocaleCheckbox;



// WEBPACK FOOTER //
// ./src/components/formFields/AutoLocaleCheckbox.js